<template>
  <div v-if="session" class="m-2">
    <v-col class="no-padding-sides">
      <!-- Back button -->
      <v-btn small :to="`/cycle/${id}/view`" tile elevation="0" color="transparent" style="color: #000" class="pl-0 pr-0 mb-5">
        <v-icon>mdi-arrow-left</v-icon>
        Retour
      </v-btn>

      <!-- Main title -->
      <h2 class="session-title">{{ session.name }}</h2>

      <!-- Session info card -->
      <v-card class="mt-5 p-2">
        <!-- Progression -->
        <v-row v-if="session.etape.progression">
          <v-col>
            <span class="font-weight-bold block-title"> {{ session.etape.progression }}</span>
          </v-col>
        </v-row>
        <!-- blocs, circuit exercises -->
        <v-row>
          <v-col>
            <span>
              Blocs <b>{{ session.block.length }}</b> | Circuits <b>{{ circuitCount }}</b> | Exercices <b>{{ exercisesCount }}</b>
            </span>
          </v-col>
        </v-row>
        <!-- Observables -->
        <v-row v-if="session.etape.etapeObservable.length > 0">
          <v-col cols="4">
            <label class="title-label">Observables</label>

            <span>
              {{ session.etape.etapeObservable | joinObservable }}
            </span>
          </v-col>
        </v-row>
        <!-- Consignes -->
        <v-row v-if="session.description">
          <v-col cols="8">
            <label class="title-label">Consigne</label>

            <p v-html="session.description" />
          </v-col>
        </v-row>
      </v-card>

      <!-- Blocks and inner exercises -->
      <div v-for="block in session.block" v-bind:key="block.id" class="mt-5">
        <blockMobile v-if="isMobile" :block="block" />
        <block v-else :block="block" />
      </div>
    </v-col>
  </div>
</template>

<script>
import { getSessionAsync } from "@/api/sessionApi";
import block from "./block";
import blockMobile from "./block.mobile";
import PermissionsService from "@/services/PermissionsService";
import AuthService from "@/services/AuthService";
import store from "@/store";

export default {
  props: {
    id: { type: String },
    sessionId: { type: String },
  },

  components: {
    block,
    blockMobile,
  },

  data() {
    return {
      authService: AuthService,
      exercisesCount: 0,
      circuitCount: 0,
      session: null,
    };
  },

  computed: {
    canViewCurrentCycle() {
      // // Can view own Cycles
      // let canViewOwnCycles = PermissionsService.CyclesPermissionsService.canViewOwnCycles && this.doesCurrentUserOwnCurrentCycle;
      // // Can view all Cycles
      // let canViewAllCycles = PermissionsService.CyclesPermissionsService.canViewAllCycles;
      // return canViewOwnCycles || canViewAllCycles;

      // Allow anonymous to read cycles
      return true;
    },
    doesCurrentUserOwnCurrentCycle() {
      return this.session && this.session.userId === this.authService.userId;
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    },
  },

  filters: {
    joinObservable: function (observables) {
      return observables.map((item) => item.observable.name).join(", ");
    },
  },

  async mounted() {
    const sessionId = parseInt(this.sessionId);

    this.session = await getSessionAsync(sessionId);

    // Check if the user can see this page
    if (!this.canViewCurrentCycle) {
      store.dispatch("setSnackbar", {
        title: `Non Autorisé`,
        text: `Vous n'êtes pas autorisé à consulter cette ressource.`,
        status: "warning",
        timeout: 2000,
      });

      this.$router.replace("/");
    }

    if (this.session) {
      this.session.block.forEach((block) => {
        this.exercisesCount += block.exercisesSets.length;

        if (block.isCircuit) this.circuitCount += 1;
      });
    }
  },
};
</script>

<style>
.session-title {
  color: #8ec67e;
  font-weight: bold;
  font-size: 26px;
}

.t-blue {
  color: #506d88 !important;
}

.title-label {
  font-weight: bold;
  color: #333;
  font-size: 16px;
}

.block-title {
  font-size: 20px;
  font-weight: bold;
  color: #8ec67e;
}

.container-video {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%;
}

.embed {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100% !important;
}

.select {
  background: #f1f1f1;
  width: 100%;
  padding: 5px;
  border-radius: 5px;
  font-weight: bold;
  position: relative;
}

.select:after {
  content: "▼";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  font-size: 60%;
  line-height: 30px;
  padding: 0 7px;
  background: #000;
  color: white;
}

.block-wrapper {
  background: #8ec67e;
}

.block-wrapper.circuit {
  background: #f7931d;
}
</style>

<style lang="scss" scoped>
b {
  font-weight: bold;
}
</style>
